/* Use the existing theme integrations; add accessible names where the legacy
   newsletter snippet does not provide a label. Safe for theme editor reloads. */
(function () {
  function setup(root) {
    root.querySelectorAll('.hm-newsletter-form input[type="email"]').forEach(function (input) {
      input.setAttribute('aria-label', 'Ihre E-Mail-Adresse für den Newsletter');
      input.setAttribute('autocomplete', 'email');
    });
    document.querySelectorAll('.template-index .menu-bar.menu-toggle:not(a):not(button)').forEach(function (trigger) {
      if (trigger.dataset.hmAccessible) return;
      trigger.dataset.hmAccessible = 'true';
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('tabindex', '0');
      trigger.setAttribute('aria-label', 'Hauptmenü öffnen');
      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          trigger.click();
        }
      });
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load', function (event) { setup(event.target); });
})();

/* Explore real product colour images without changing the cart. */
(function () {
  function setupColors(root) {
    root.querySelectorAll('[data-hm-color-banner]').forEach(function (banner) {
      if (banner.dataset.hmColorsReady) return;
      banner.dataset.hmColorsReady = 'true';
      var buttons = Array.from(banner.querySelectorAll('[data-hm-color]'));
      var slider = banner.querySelector('[data-hm-color-slider]');
      var image = banner.querySelector('.hm-phonak-image');
      if (!buttons.length || !slider || !image) return;
      var selected = Math.max(0, buttons.findIndex(function (button) { return button.getAttribute('aria-checked') === 'true'; }));
      var request = 0;
      function select(index, loadImage) {
        selected = Math.max(0, Math.min(buttons.length - 1, index));
        var button = buttons[selected];
        buttons.forEach(function (item, position) {
          item.setAttribute('aria-checked', String(position === selected));
          item.tabIndex = position === selected ? 0 : -1;
        });
        slider.value = selected;
        slider.setAttribute('aria-valuetext', button.dataset.hmColor);
        banner.querySelector('[data-hm-color-name]').textContent = button.dataset.hmColor;
        banner.querySelector('[data-hm-color-count]').textContent = (selected + 1) + ' / ' + buttons.length;
        banner.querySelectorAll('[data-hm-color-link]').forEach(function (link) { link.href = button.dataset.hmVariantUrl; });
        if (!loadImage) return;
        var token = ++request;
        var preview = new Image();
        image.classList.add('is-changing');
        preview.onload = function () {
          if (token !== request) return;
          image.removeAttribute('srcset');
          image.src = button.dataset.hmImage;
          image.alt = 'Phonak Audéo Eon – ' + button.dataset.hmColor;
          image.classList.remove('is-changing');
        };
        preview.onerror = function () { if (token === request) image.classList.remove('is-changing'); };
        preview.src = button.dataset.hmImage;
      }
      buttons.forEach(function (button, index) {
        button.addEventListener('click', function () { select(index, true); });
        button.addEventListener('keydown', function (event) {
          var next = selected;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (selected + 1) % buttons.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (selected - 1 + buttons.length) % buttons.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = buttons.length - 1;
          else return;
          event.preventDefault();
          select(next, true);
          buttons[next].focus();
        });
      });
      slider.addEventListener('input', function () { select(Number(slider.value), true); });
      select(selected, false);
      // Load the other colours when the banner comes into view, so sliding feels immediate.
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
          buttons.forEach(function (button) { var preview = new Image(); preview.src = button.dataset.hmImage; });
          observer.disconnect();
        }, { rootMargin: '200px' });
        observer.observe(banner);
      }
    });
  }
  setupColors(document);
  document.addEventListener('shopify:section:load', function (event) { setupColors(event.target); });
})();

(function () {
  function setupLatest(root) {
    root.querySelectorAll('[data-hm-latest-carousel]').forEach(function (carousel) {
      if (carousel.dataset.hmLatestReady) return;
      carousel.dataset.hmLatestReady = 'true';
      var track = carousel.querySelector('[data-hm-latest-track]');
      var slides = Array.from(carousel.querySelectorAll('[data-hm-latest-slide]'));
      var choices = Array.from(carousel.querySelectorAll('[data-hm-latest-go]'));
      var prev = carousel.querySelector('[data-hm-latest-prev]');
      var next = carousel.querySelector('[data-hm-latest-next]');
      if (!slides.length) return;
      var active = 0;
      var scheduled = false;
      function update() {
        active = slides.reduce(function (closest, slide, index) {
          return Math.abs(slide.offsetLeft - track.scrollLeft) < Math.abs(slides[closest].offsetLeft - track.scrollLeft) ? index : closest;
        }, 0);
        prev.disabled = active === 0;
        next.disabled = active === slides.length - 1;
        choices.forEach(function (button, index) { button.setAttribute('aria-pressed', String(index === active)); });
        carousel.querySelector('[data-hm-latest-count]').textContent = String(active + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
      }
      function go(index) {
        var target = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({ left: slides[target].offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      prev.addEventListener('click', function () { go(active - 1); });
      next.addEventListener('click', function () { go(active + 1); });
      choices.forEach(function (button, index) { button.addEventListener('click', function () { go(index); }); });
      track.addEventListener('keydown', function (event) {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight') { event.preventDefault(); go(active + 1); }
        else if (event.key === 'ArrowLeft') { event.preventDefault(); go(active - 1); }
        else if (event.key === 'Home') { event.preventDefault(); go(0); }
        else if (event.key === 'End') { event.preventDefault(); go(slides.length - 1); }
      });
      track.addEventListener('scroll', function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () { scheduled = false; update(); });
      }, { passive: true });
      var lastWidth = track.clientWidth;
      new ResizeObserver(function () {
        if (lastWidth !== track.clientWidth) {
          lastWidth = track.clientWidth;
          track.scrollTo({ left: slides[active].offsetLeft, behavior: 'instant' });
        }
        update();
      }).observe(track);
      update();
    });
  }
  setupLatest(document);
  document.addEventListener('shopify:section:load', function (event) { setupLatest(event.target); });
})();

(function () {
  function setupOrbit(root) {
    root.querySelectorAll('[data-hm-orbit]').forEach(function (carousel) {
      if (carousel.dataset.hmOrbitReady) return;
      var items = Array.from(carousel.querySelectorAll('[data-hm-orbit-item]'));
      var panels = Array.from(carousel.querySelectorAll('[data-hm-orbit-panel]'));
      var stage = carousel.querySelector('[data-hm-orbit-stage]');
      if (!items.length || items.length !== panels.length) return;
      carousel.dataset.hmOrbitReady = 'true';
      var active = 0;
      function select(index) {
        active = (index + items.length) % items.length;
        items.forEach(function (item, i) {
          var distance = (i - active + items.length) % items.length;
          item.dataset.position = distance === 0 ? 'front' : distance === 1 ? 'right' : distance === items.length - 1 ? 'left' : 'back';
          item.setAttribute('aria-pressed', String(i === active));
          panels[i].hidden = i !== active;
        });
        carousel.dataset.activeModel = String(active);
        carousel.querySelectorAll('[data-hm-orbit-go]').forEach(function (button, i) { button.setAttribute('aria-pressed', String(i === active)); });
        carousel.querySelector('[data-hm-orbit-count]').textContent = String(active + 1).padStart(2, '0') + ' / ' + String(items.length).padStart(2, '0');
      }
      var choices = Array.from(carousel.querySelectorAll('[data-hm-orbit-go]'));
      choices.forEach(function (button, index) { button.addEventListener('click', function () { select(index); }); });
      var suppressClick = false;
      items.forEach(function (item, index) { item.addEventListener('click', function () { if (!suppressClick) select(index); }); });
      carousel.querySelector('[data-hm-orbit-prev]').addEventListener('click', function () { select(active - 1); });
      carousel.querySelector('[data-hm-orbit-next]').addEventListener('click', function () { select(active + 1); });
      stage.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') { event.preventDefault(); select(active + 1); }
        else if (event.key === 'ArrowLeft') { event.preventDefault(); select(active - 1); }
        else if (event.key === 'Home') { event.preventDefault(); select(0); }
        else if (event.key === 'End') { event.preventDefault(); select(items.length - 1); }
      });
      var start = null;
      stage.addEventListener('pointerdown', function (event) {
        if (!event.isPrimary || event.button !== 0) return;
        start = { x: event.clientX, y: event.clientY, id: event.pointerId };
        suppressClick = false;
      });
      stage.addEventListener('pointerup', function (event) {
        if (!start || event.pointerId !== start.id) return;
        var dx = event.clientX - start.x, dy = event.clientY - start.y;
        start = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) {
          suppressClick = true;
          select(active + (dx < 0 ? 1 : -1));
          setTimeout(function () { suppressClick = false; }, 0);
        }
      });
      stage.addEventListener('pointercancel', function () { start = null; });
      stage.addEventListener('pointerleave', function () { start = null; });
      select(0);
    });
  }
  setupOrbit(document);
  document.addEventListener('shopify:section:load', function (event) { setupOrbit(event.target); });
})();
